<template>
  <v-system-bar
    v-if="active"
    app
    window
    color="deep-orange darken-3"
    dark
  >
    <v-icon small class="mr-1">mdi-source-branch</v-icon>
    <span class="text-caption">
      {{ followingBranch
        ? $t('components.NgtorchOverrideBanner.activeBranch', { ref: ngtorchOverride.ref })
        : $t('components.NgtorchOverrideBanner.active', { ref: ngtorchOverride.ref, sha: shortSha }) }}
    </span>
    <span v-if="ngtorchOverride.reinstall" class="text-caption ml-2">
      {{ $t('components.NgtorchOverrideBanner.reinstalling') }}
    </span>
    <v-spacer></v-spacer>
    <v-btn text x-small :to="{ name: 'adminTools' }">
      {{ $t('components.NgtorchOverrideBanner.manage') }}
    </v-btn>
    <v-btn text x-small :loading="disabling" @click="disable">
      {{ $t('components.NgtorchOverrideBanner.disable') }}
    </v-btn>
  </v-system-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

// Shown on every page for as long as an ngtorch override is pinned. A forgotten override is the
// main hazard of the feature, so this is deliberately not hidden on the chrome-less layouts.
export default {
  data () {
    return {
      disabling: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'ngtorchOverride'
    ]),
    active () {
      return Boolean(this.ngtorchOverride) && this.ngtorchOverride.enabled === true
    },
    // A followed branch has no one sha to name here: the run that boots next reads the head again.
    // Naming the last resolved one in a one-line bar would read as a pin, so the bar names the
    // branch and adminTools carries the detail.
    followingBranch () {
      return this.active && this.ngtorchOverride.kind !== 'commit'
    },
    shortSha () {
      if (!this.ngtorchOverride) return ''
      if (this.ngtorchOverride.short_sha) return this.ngtorchOverride.short_sha
      return this.ngtorchOverride.sha ? this.ngtorchOverride.sha.slice(0, 7) : ''
    }
  },
  methods: {
    ...mapActions('admin', [
      'clearNgtorchOverride'
    ]),
    async disable () {
      this.disabling = true
      try {
        await this.clearNgtorchOverride()
      } catch (error) {
        console.error('Could not disable the ngtorch override', error)
      } finally {
        this.disabling = false
      }
    }
  }
}
</script>
